import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {},
    link: {
        display: 'flex',
        boxSizing: 'content-box',
        height: 24,
        padding: '11px 16px',
        fontSize: '1rem',
        color: theme.palette.text.primary,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textDecoration: 'none',
        fontWeight: 500,
        cursor: 'pointer',
    },
    subLink: {
        fontSize: '0.9rem',
    },
    selected: {
        color: theme.palette.secondary.main,
    },
    icon: {
        width: 24,
        height: 24,
        marginRight: 16,
        color: theme.palette.text.primary,
    },
    children: {
        marginLeft: 16,
    },
});
const NavMenuNode = props => {
    const { classes, node, onClick } = props;
    const className = classNames(classes.link, {
        [classes.selected]: node.selected,
        [classes.subLink]: node.deep > 1,
    });
    const IconComponent = node.icon;
    const icon = node.icon ? <IconComponent /> : null;
    const children = node.children.filter(child => child.visible);
    const isCollapse = node.role === 'collapse';
    const showChildren = !isCollapse || (isCollapse && node.expanded);
    return (
        <div className={classes.root}>
            <Typography
                className={className}
                component={
                    !isCollapse
                        ? Link
                        : ({ children, className, onClick }) => (
                              <div className={className} onClick={onClick}>
                                  {children}
                              </div>
                          )
                }
                to={node.url}
                onClick={() => onClick(node)}
            >
                <div className={classes.icon}>{icon}</div>
                {node.label}
            </Typography>
            {node.active && (node.selected || showChildren) && (
                <div className={classes.children}>
                    {children.map(child => (
                        <NavMenuNode
                            key={child.url}
                            node={child}
                            onClick={onClick}
                            classes={classes}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default withStyles(styles)(NavMenuNode);
